import React from 'react';
import { string } from 'prop-types';
import * as styles from './styles/styles.module.scss';

type TrailResultCardShimmerProps = {
  className?: string;
};

const TrailResultCardShimmer = ({ className }: TrailResultCardShimmerProps): JSX.Element => {
  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.image} />
      <div className={styles.metadataContainer}>
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export default TrailResultCardShimmer;
